// extracted by mini-css-extract-plugin
export var statItem = "_mb-1";
export var statsRow = "_mb-0";